import { FC, useMemo } from "react";
import MainCart from "../../../Cart/MainCart";
import ProgressBar from "../../../ProgressiveBar";
import Navigation from "../../../App/Navigation";
import { ROUTES } from "../../../../consts";
import { useTrackContext } from "../../../../hooks/useTrackContext";

const ReviewCart: FC = () => {
  const { productRenderedLocation, windowWidth } = useTrackContext();

  const previousRoute = useMemo(() => ROUTES.INDEX + ROUTES.VIRTUAL_REALITY.DATE_TIME, []);

  return (
    <>
      <ProgressBar maxValue={100} currentValue={windowWidth <= 768 ? 90 : 95} />
      <div className="tw-block lg:tw-hidden">
        {/* <div className="tw-text-white tw-text-center tw-mt-[50px] tw-mb-[30px] tw-text-[24px] tw-font-[800]">Review your Cart</div> */}
      </div>
      <div className="tw-hidden lg:tw-block">
        {/* <Navigation
          previous={{
            active: true,
            to: previousRoute,
          }}
          next={{ active: false, to: "#" }}
          title={"Review your Cart"}
        /> */}
      </div>
      <MainCart />
      <div className="tw-w-full lg:tw-h-[126px] tw-p-[30px] tw-mt-[40px] lg:tw-mt-0">
        <div className="tw-flex tw-justify-center tw-items-center">
          <div className="tw-block lg:tw-hidden">
            <Navigation
              previous={{
                active: true,
                to: previousRoute,
              }}
              next={{ active: false, to: "#" }}
              title={"Review your Cart"}
              subtitle={"Virtual Reality"}
            />
          </div>
          <div
            className={`${productRenderedLocation === "external" ? "tw-container tw-mx-auto" : "container mx-auto"} tw-relative tw-flex tw-justify-end tw-items-center lg:tw-block`}
          >
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewCart;
